import { FaDatabase, FaChartLine, FaChalkboardTeacher, FaPlug, FaCogs, FaHeadset } from "react-icons/fa";
import images from "./images";

const process = [
  {
    id: 1,
    icon: <FaDatabase />,
    image: images.step1,
    title: "Data Collection",
    content: "We collect relevant data from diverse sources, fueling the AI engine for accurate insights and predictions.",
  },
  {
    id: 2,
    icon: <FaChartLine />,
    image: images.step2,
    title: "Data Analysis",
    content: "We apply advanced machine learning techniques to analyze the data and build predictive models.",
  },
  {
    id: 3,
    icon: <FaChalkboardTeacher />,
    image: images.step3,
    title: "AI Training",
    content: "We train AI models using high-quality datasets to enhance their performance and accuracy.",
  },
  {
    id: 4,
    icon: <FaPlug />,
    image: images.step4,
    title: "AI Integration",
    content: "We seamlessly integrate AI models into your system for automated processes and smarter decisions.",
  },
  {
    id: 5,
    icon: <FaCogs />,
    image: images.step5,
    title: "System Testing",
    content: "We conduct thorough testing to ensure the system performs effectively under various conditions.",
  },
  {
    id: 6,
    icon: <FaHeadset />,
    image: images.step6,
    title: "Continuous Support",
    content: "We provide ongoing support to ensure optimal performance and continuous improvement of your system.",
  },
];

export default process;